// customAlert.js

// Hook para inicializar el reemplazo de window.alert (una sola vez)
export function overrideWindowAlert() { // Función para reemplazar window.alert
  if (document.getElementById) {
    window.alert = function (title,alertMessage) {
      customAlert(title,alertMessage);
    };
  }
}

function customAlert(title,alertMessage) { // Función para mostrar la alerta
  const ALERT_TITLE = title;
  const ALERT_BUTTON_TEXT = "OK";

  // Evita crear múltiples alertas
  if (document.getElementById("alert_container")) return;

  const body = document.querySelector("body");

  // Crear contenedor principal
  const alertContainer = document.createElement("div");
  alertContainer.id = "alert_container";
  alertContainer.className = "alert_container";

  // Crear caja de alerta
  const alertBox = document.createElement("div");
  alertBox.className = "alert_box";

  // Posicionar la alerta (puedes mejorar esto con CSS)
  alertBox.style.position = "fixed";
  alertBox.style.left = "50%";
  alertBox.style.bottom = "120px";
  alertBox.style.top = "";
  alertBox.style.transform = "translateX(-50%)";
  alertBox.style.backgroundColor = "#f8d7da";
  alertBox.style.padding = "20px";
  alertBox.style.border = "1px solid #f5c6cb";
  alertBox.style.borderRadius = "8px";
  alertBox.style.zIndex = "9999";
  alertBox.style.boxShadow = "0 0 10px rgba(0,0,0,0.2)";
  alertBox.style.minWidth = "300px";
  alertBox.style.textAlign = "center";

  // Título
  const titleElement = document.createElement("h1");
  titleElement.innerText = ALERT_TITLE;
  titleElement.style.fontSize = "18px";
  titleElement.style.marginBottom = "10px";
  alertBox.appendChild(titleElement);

  // Mensaje
  const messageElement = document.createElement("p");
  messageElement.textContent = alertMessage;
  alertBox.appendChild(messageElement);

  // Botón
  const okButton = document.createElement("button");
  okButton.className = "close_btn";
  okButton.textContent = ALERT_BUTTON_TEXT;
  okButton.style.marginTop = "15px";
  okButton.style.padding = "8px 16px";
  okButton.style.backgroundColor = "#dc3545";
  okButton.style.color = "white";
  okButton.style.border = "none";
  okButton.style.borderRadius = "4px";
  okButton.style.cursor = "pointer";

  okButton.addEventListener("click", () => {
    body.removeChild(alertContainer);
  });

  // Desaparecer automáticamente después de 3 segundos
  setTimeout(() => {
    if (document.body.contains(alertContainer)) {
      body.removeChild(alertContainer);
    }
  }, 5000);

  alertBox.appendChild(okButton);
  alertContainer.appendChild(alertBox);
  body.appendChild(alertContainer);
}
